import React, { Component } from 'react';
import Constants from '../constants/Constants';

export default class GameTimer extends Component {
    constructor(props) {
        super(props);
        this.gameCtx = props.gameCtx;
        this.interval = null;

        this.state = {
            tSeconds: null,
            cssWhilePlaying: true
        };
    }

    startTimer = (tSeconds = Constants.SECONDS_PER_PLAYING_SESSION) => {
        clearInterval(this.interval);

        let cb = () => {
            this.interval = setInterval(() => {
                if (this.state.tSeconds === 2) {
                    clearInterval(this.interval);
                    this.forwardNextTurn();
                }
                if (this.state.tSeconds === Constants.MIN_SECONDS_BEFORE_FLASH_TIMER + 1) {
                    this.gameCtx.soundRepository.playSoundByName(Constants.SOUND_TICK);
                }
                this.setState({ tSeconds: this.state.tSeconds - 1 });
            }, 1000);
        }

        if (tSeconds <= 1) {
            tSeconds = Constants.SECONDS_PER_PLAYING_SESSION
        }

        if (this.gameCtx.gameStatus === Constants.GAME_STATUS_PAUSED) {
            return;
        }

        this.setState({ tSeconds: tSeconds }, cb)
    }

    pauseTimer = () => {
        clearInterval(this.interval);
        this.setState({ cssWhilePlaying: false });

    }

    resumeTimer = () => {
        this.startTimer(this.state.tSeconds);
        this.setState({ cssWhilePlaying: true });

    }

    forwardNextTurn = () => {
        let cEntity = this.gameCtx.gameSeqHandler.getCurrentEntity();
        cEntity.endTurn();
        cEntity.turnStatus = Constants.TURN_STATUS_END;
    }

    resetTimer = () => {
        this.setState({ tSeconds: Constants.SECONDS_PER_PLAYING_SESSION })
    }

    render() {
        let flickerStyle = this.state.tSeconds <= Constants.MIN_SECONDS_BEFORE_FLASH_TIMER && this.props.gameCtx.gameStatus === Constants.GAME_STATUS_PLAYING ?
            {
                WebkitAnimation: "flickerAnimation .9s infinite",
                MozAnimation: "flickerAnimation .9s infinite",
                OAnimation: "flickerAnimation .9s infinite",
                animation: "flickerAnimation .9s infinite",

            } : {};
        return (
            <div
                style={flickerStyle}
                className="game-timer"
                draggable="false">
                {this.state.tSeconds}
            </div>);
    }
}